/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Rule} from "../models/rule";
import {RulesService} from "../services/rules.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";
import { Dialog } from "app/models/dialog";
import { DialogService } from "app/services/dialog.service";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class DialogsPagingResolver implements Resolve<PagedResults<Dialog>> {

  constructor(
    private mRuleService: RulesService,
    private mDialogService: DialogService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<Dialog>> {
    try {
      return await this.mDialogService.getAllDialogsForPaging(0, PAGING_ITEMS_PER_PAGE, 'ASC', "");
    } catch (error) {
      console.error("Problem resolving Dialogs... Error: " + error, error);
    }
  }

}
